const classifyApiList = {
  addClassify: '/manage/goods/category/add',
  classifyList: '/manage/goods/category/list'
}
export default classifyApiList



// WEBPACK FOOTER //
// ./src/service/basic/classifyApiList.js